import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"column-wide-add"} maskId="square-filled-radius-0-stroke-1-IconColumnWideAdd"><path d="M2 4V20H12.5V5L21 5V12H22V4L2 4Z" fill="currentColor"/><path d="M20 14H19V17H16V18H19V21H20V18H23V17H20V14Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColumnWideAdd;
